import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=f833fde4"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=f833fde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports